// DownloadButton.js
"use client";

import React from "react";
import { Button } from "@heroui/button";

const DownloadButton = ({ pdfUrl }) => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.setAttribute("download", ""); // Or set a specific filename here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button
      size="sm"
      onPress={handleDownload}
      className=" bg-1B51CA text-white  transition duration-300 ease-in-out"
    >
      Download PDF
    </Button>
  );
};

export default DownloadButton;
